const config = {
  api_url: "https://incident-alert.ask-dom.com/api",
  websocket: "wss://incident-alert.ask-dom.com/ws/",
  sockjs: "https://incident-alert.ask-dom.com/ws/"
};
export default config;
